import { useContext, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { TransactionalSubheader } from "iuvity-ui-components/dist/transactionalsubheader";
import { TabView } from "iuvity-ui-components/dist/tabview";
import { BoxFull } from "iuvity-ui-components/dist/boxfull";
import { Header } from "../../components/header/Header";
import {
  CustomDialog,
  DialogProps,
} from "../../components/dialog/CustomDialog";
import { useProperties } from "../../hooks/useProperties";
import { useTransactions } from "../../hooks/useTransactions";
import { useVersions } from "../../hooks/useVersions";
import { AppContext } from "../../context/index";
import { TransactionsInfo } from "../../components/transactions/TransactionsInfo";
import { PropertiesInfo } from "../../components/shared/PropertiesInfo";

export const AdminTransactionPage = () => {
  const navigate = useNavigate();
  const {
    t,
    appState: { user },
    setAppState,
  } = useContext(AppContext);

  const {
    data: transactionsData,
    transactionAction,
    reloadFn: transactionReloadFn,
  } = useTransactions("DATA");

  const {
    data: propertiesData,
    propertyAction,
    reloadFn: propertyReloadFn,
  } = useProperties("DATA", "transaction");

  const { data: versionsData } = useVersions("DATA");

  const [activeIndex, setActiveIndex] = useState<number>(0);
  const [auxModal, auxModalController] = useState<DialogProps>({
    visible: false,
  } as DialogProps);

  const formOptions = useMemo(() => {
    if (transactionsData && propertiesData && versionsData) {
      return {
        names: transactionsData
          .map((transaction) => ({
            label: transaction?.name,
            value: transaction?.name,
          }))
          .sort((a: any, b: any) => a.label.localeCompare(b.label)),
        versions: versionsData
          .map((version: any) => ({
            label: version?.name,
            value: version?.name,
          }))
          .sort((a: any, b: any) => b.label.localeCompare(a.label)),
      };
    } else {
      return;
    }
  }, [transactionsData, propertiesData, versionsData]);

  return (
    <>
      {/* <Header
        welcomeMessage={t("Dashboard.welcomeTitle")}
        userName={user?.name}
      /> */}
      <TransactionalSubheader
        subheaderTitle={
          <div>
            {t("Transactions.transactionAdminTitle")}
          </div>
        }
      >
        <TransactionalSubheader.BreadCrumb
          id={t("Transactions.transactionAdminTitle")}
          disabledDefaultHome={true}
          breadcrumbsHomeItem={{
            icon: "iu iu-icon-home",
            command: () => navigate("/"),
          }}
          breadcrumbsItems={[
            {
              label: t("Transactions.transactionAdminTitle"),
              style: { fontWeight: "bold" },
              disabled: true
            },
          ]}
        />
        <TransactionalSubheader.Title />
        <div className="t-subheader-content">
          <span>{t("Transactions.adminDescriptionLabel")}</span>
        </div>
      </TransactionalSubheader>

      <BoxFull className="my-4 px-0 py-0" variant="tertiary">
        <TabView
          className="upload-tabview mt-4"
          activeIndex={activeIndex}
          onTabChange={(e) => {
            setActiveIndex(e.index);
            setAppState((prev) => ({
              ...prev,
              functionalityCode: e.index === 1
                ? '/transactions/properties'
                : '/transactions',
            }));
          }}
          items={[
            {
              key: "1",
              header: t("Transactions.transactionTypesTitle"),
              children: (
                <TransactionsInfo
                  data={transactionsData}
                  options={formOptions}
                  actionFn={transactionAction}
                  reloadFn={transactionReloadFn}
                  auxModalController={auxModalController}
                />
              ),
            },
            {
              key: "2",
              header: t("Transactions.transactionPropertiesTitle"),
              children: (
                <PropertiesInfo
                  title={t("Transactions.transactionPropertiesAdminTitle")}
                  data={propertiesData}
                  options={formOptions}
                  actionFn={propertyAction}
                  reloadFn={propertyReloadFn}
                  type="transaction"
                  auxModalController={auxModalController}
                />
              ),
            },
          ]}
        />
      </BoxFull>

      <CustomDialog
        title={auxModal.title}
        visible={auxModal.visible}
        content={auxModal.content}
        handleModalState={auxModalController}
        onConfirm={auxModal.onConfirm}
      />
    </>
  );
};
